(() => {
  if (window.__WN_CART_CARE_V21__) return;
  window.__WN_CART_CARE_V21__ = true;

  const START = 57245448175940;
  const NORMAL = 56956372189508;
  const NAMI = 15580935422276;
  const CARE = 698734412100;
  const PLUS = 698734346564;
  let queue = Promise.resolve();
  let guarding = null;

  const serial = (work) => { const next = queue.then(work, work); queue = next.catch(() => {}); return next; };
  const id = (value) => Number(String(value || '').split('/').pop()) || 0;
  const cart = () => window.WNCart.refresh({ emit: false, source: 'care-read', openDrawer: false });
  const update = (updates) => window.WNCart.update({ updates }, { source: 'care-normalize', openDrawer: false, emit: false });
  const add = async (items) => (await window.WNCart.add({ items }, { source: 'care-compose', openDrawer: false, emit: false })).cart;
  const publish = (state, source) => state?.items ? window.WNCart.publish(state, { source, openDrawer: false, wnCareValidated: true }) : window.WNCart.refresh({ emit: true, source, openDrawer: false });

  const careType = (item) => {
    const property = String(item?.properties?.['_Wandersnout Filter Care'] || '').toLowerCase();
    const handle = String(item?.handle || item?.product_handle || '').toLowerCase();
    if (property === 'care+' || handle === 'nami-filter-care-enrollment' || handle === 'nami-filter-care-plus') return 'plus';
    if (property === 'care' || handle === 'nami-filter-care') return 'care';
    return null;
  };
  const planId = (item) => id(item?.selling_plan_allocation?.selling_plan?.id || item?.selling_plan_allocation?.selling_plan_id || item?.selling_plan);
  const validCare = (item) => (careType(item) === 'care' && planId(item) === CARE) || (careType(item) === 'plus' && planId(item) === PLUS);
  const normalizeTier = (value) => value === 'plus' || value === 'care-plus' ? 'plus' : value === 'care' ? 'care' : value === 'starter' || value === 'one-time' ? 'starter' : 'none';
  const filterVariantId = (source) => Number(source?.dataset.filterVariantId || NORMAL);
  const normalFilters = (state, source) => state.items.filter((item) => Number(item.variant_id) === filterVariantId(source));
  const starterHelpers = (state) => state.items.filter((item) => Number(item.variant_id) === START);
  const careHelpers = (state) => state.items.filter((item) => careType(item));
  const namiQuantity = (state) => state.items.reduce((total, item) => total + (Number(item.product_id) === NAMI ? Number(item.quantity || 0) : 0), 0);

  function tierFromCart(state, source) {
    const active = careHelpers(state).find(validCare);
    if (active) return careType(active);
    if (normalFilters(state, source).some((item) => Number(item.quantity || 0) > 0)) return 'starter';
    return 'none';
  }

  function renderState(ui, tier) {
    const normalized = normalizeTier(tier);
    ui.querySelectorAll('[data-care-option]').forEach((option) => {
      const active = normalizeTier(option.dataset.careOption) === normalized;
      option.classList.toggle('is-active', active);
      const input = option.querySelector('[data-wn-care-toggle]');
      if (input) input.checked = active;
    });
    const root = ui.closest('[data-cart-drawer-content],wn-cart-page,wn-cart-drawer');
    if (root) root.dataset.wnCareState = normalized;
  }

  async function choose(source, choice) {
    let state = window.WNCart?.getState?.();
    if (!state?.items) state = await cart();
    const maxFilters = Math.max(1, namiQuantity(state));
    const updates = {};
    const normal = normalFilters(state, source);
    const starter = starterHelpers(state);
    careHelpers(state).forEach((item) => { updates[item.key] = 0; });

    if (choice.target === 'none') [...normal, ...starter].forEach((item) => { updates[item.key] = 0; });
    else if (choice.target === 'starter') {
      starter.forEach((item) => { updates[item.key] = 0; });
      if (normal[0]) {
        const wanted = Math.min(maxFilters, Math.max(1, Number(normal[0].quantity || 1)));
        if (Number(normal[0].quantity) !== wanted) updates[normal[0].key] = wanted;
      }
      normal.slice(1).forEach((item) => { updates[item.key] = 0; });
    } else {
      normal.forEach((item) => { updates[item.key] = 0; });
      if (starter[0] && Number(starter[0].quantity) !== 1) updates[starter[0].key] = 1;
      starter.slice(1).forEach((item) => { updates[item.key] = 0; });
    }

    if (Object.keys(updates).length) state = await update(updates);
    if (choice.target === 'none') return state;
    const items = [];
    if (choice.target === 'starter') {
      if (!normalFilters(state, source).length) items.push({ id: filterVariantId(source), quantity: 1 });
    } else {
      if (!starterHelpers(state).length) items.push({ id: START, quantity: 1, properties: { '_Wandersnout Care Starter': 'true' } });
      if (!choice.variantId || !choice.planId) throw new Error('Care config missing');
      items.push({ id: choice.variantId, quantity: 1, selling_plan: choice.planId, properties: { '_Wandersnout Filter Care': choice.target === 'plus' ? 'Care+' : 'Care', '_Do not fulfill': 'Virtual subscription enrollment' } });
    }
    if (items.length) state = await add(items);
    return state;
  }

  async function guard(source, refreshView = true, seed = null) {
    if (guarding) return guarding;
    guarding = (async () => {
      let state = seed && Array.isArray(seed.items) ? seed : await cart();
      const updates = {};
      const namiQty = namiQuantity(state);
      const normal = normalFilters(state, source);
      const starter = starterHelpers(state);
      const helpers = careHelpers(state);
      const careIsValid = namiQty > 0 && helpers.length === 1 && helpers.filter(validCare).length === 1;
      let needStarter = false;

      if (helpers.length && !careIsValid) {
        helpers.forEach((item) => { updates[item.key] = 0; });
        starter.forEach((item) => { updates[item.key] = 0; });
      } else if (careIsValid) {
        normal.forEach((item) => { updates[item.key] = 0; });
        if (starter[0] && Number(starter[0].quantity) !== 1) updates[starter[0].key] = 1;
        starter.slice(1).forEach((item) => { updates[item.key] = 0; });
        needStarter = !starter.length;
      } else {
        starter.forEach((item) => { updates[item.key] = 0; });
        if (namiQty > 0 && normal.length) {
          const wanted = Math.min(namiQty, Math.max(1, normal.reduce((sum, item) => sum + Number(item.quantity || 0), 0)));
          if (Number(normal[0].quantity) !== wanted) updates[normal[0].key] = wanted;
          normal.slice(1).forEach((item) => { updates[item.key] = 0; });
        }
      }

      let changed = false;
      if (Object.keys(updates).length) { state = await update(updates); changed = true; }
      if (needStarter) { state = await add([{ id: START, quantity: 1, properties: { '_Wandersnout Care Starter': 'true' } }]); changed = true; }
      if (changed && refreshView) publish(state, 'care-dependency-guard');
      return state;
    })().finally(() => { guarding = null; });
    return guarding;
  }

  async function prepareCheckout(seed = null) {
    const source = document.querySelector('[data-wn-cart-care-source]');
    let state = seed && Array.isArray(seed.items) ? seed : await cart();
    if (starterHelpers(state).length || careHelpers(state).length) state = await guard(source, false, state);
    const starter = starterHelpers(state), helpers = careHelpers(state);
    const internal = starter.length > 0 || helpers.length > 0;
    const valid = namiQuantity(state) > 0 && starter.length === 1 && helpers.length === 1 && helpers.filter(validCare).length === 1;
    if (internal && !valid) { await window.WNCart.refresh({ emit: true, source: 'care-security-block', openDrawer: false }); return null; }
    return state.items.length ? state : null;
  }

  function mount(source, seed = null) {
    const root = source.closest('[data-cart-drawer-content]') || source.closest('wn-cart-page') || source.closest('wn-cart-drawer') || source.parentElement;
    const content = root?.querySelector('[data-cart-content]');
    const extras = content?.querySelector('.wn-cart-nami-bundle__extras');
    if (!root || !content || !extras) return;
    root.classList.add('wn-care-controls-mounted');
    let ui = extras.querySelector('[data-wn-cart-care-chooser]');
    if (!ui) {
      const template = source.querySelector('template[data-wn-cart-care-template]');
      if (!template) return;
      extras.append(template.content.cloneNode(true));
      ui = extras.querySelector('[data-wn-cart-care-chooser]');
    }
    if (!ui) return;

    const state = seed?.items ? seed : window.WNCart?.getState?.();
    const hasVisibleFilters = Boolean(content.querySelector('.wn-cart-item--nami-addon'));
    const tier = source.dataset.plusKey ? 'plus' : source.dataset.careKey ? 'care' : hasVisibleFilters ? 'starter' : state?.items ? tierFromCart(state, source) : 'none';
    renderState(ui, tier);

    if (ui.dataset.v21) return;
    ui.dataset.v21 = '1';
    ui.addEventListener('change', (event) => {
      const input = event.target.closest('[data-wn-care-toggle]');
      if (!input?.checked) return;
      const choice = { target: normalizeTier(input.dataset.careTier), variantId: Number(input.dataset.careVariantId || 0), planId: Number(input.dataset.careSellingPlanId || 0) };
      renderState(ui, choice.target);
      serial(async () => {
        ui.setAttribute('aria-busy', 'true');
        try { publish(await choose(source, choice), 'care-v21-choice'); }
        catch (error) { console.warn('Nami Care', error); await window.WNCart.refresh({ emit: true, source: 'care-v21-error', openDrawer: false }).catch(() => {}); }
        finally { ui.removeAttribute('aria-busy'); }
      });
    });
    ui.addEventListener('click', (event) => {
      const option = event.target.closest('[data-care-option]');
      if (!option || event.target.closest('a,button,summary')) return;
      const input = option.querySelector('[data-wn-care-toggle]');
      if (input && !input.checked) { event.preventDefault(); input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }

  function mountAll(seed = null) { document.querySelectorAll('[data-wn-cart-care-source]').forEach((source) => mount(source, seed)); }
  let frame = 0, pendingState = null;
  function schedule(event) {
    if (event?.detail?.cart) pendingState = event.detail.cart;
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const state = pendingState || window.WNCart?.getState?.() || null;
      pendingState = null;
      mountAll(state);
      const source = document.querySelector('[data-wn-cart-care-source]');
      if (source) serial(() => guard(source, true, state)).catch(() => {});
    });
  }

  document.addEventListener('wn:cart:updated', schedule);
  document.addEventListener('wn:cart:view-refreshed', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
  window.WNCartCare = Object.freeze({ prepareCheckout: (seed) => serial(() => prepareCheckout(seed)) });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();
